import { Component, OnInit, Input, effect, signal } from '@angular/core';
import {
  DispositionReasonValue,
  DispositionService,
  Student,
  AdmissionsService,
  UIConfiguration,
  UserService,
  DialerContactService,
  ValidDispositionRequested,
  CallService,
  DisconnectCallRequest,
  InvalidDispositionRequested,
  StitchInCallRequested,
  SendPstNotificationResponse,
  DialerCampaignsService,
  InvalidLeadDialerCampaignSettingsResponse,
  LeadService,
  MarkUncallableRequest,
  DisconnectEmailRequest,
  DialerContactResponse
} from '../../../lib';
import { AdmissionUIMessengerService } from '../admission-ui-messenger.service';
import { AdmissionUICommonDataService } from '../admission-ui-common-data.service';
import { ConfirmationDialogComponent, CONFIRM_DIALOG_MODE } from '../confirmation-dialog/confirmation-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { GenesysSparkWrapperService } from '../genesys-spark-wrapper.service';
import { ToastService } from '../../toast/toast.service';
import { catchError, combineLatest, forkJoin, interval, Observable, of, Subscription, switchMap } from 'rxjs';
import { convert as convertHtmlToText } from 'html-to-text';
import { LeadConversationState, LeadConversationStateStore } from '../../dialpad/leadConversation.state';
import { PSTService } from '../pst.service';
import { DateFormatterUtils } from '../../shared/dateformatter.utils';
import { AppInsightsService } from '../../app-insights.service';
import { ConversationUtils } from '../../shared/conversation.utils';



@Component({
  selector: 'app-disposition-screen',
  templateUrl: './disposition-screen.component.html',
  styleUrl: './disposition-screen.component.scss'
})
export class DispositionScreenComponent implements OnInit {
  @Input() buttonType: string = 'primary';
  @Input() previousUserCallStatus: string = 'Available';
  @Input() callSkills: string[] = [];

  studentData!: Student;
  studentId!: number;
  conversationId: string | undefined;
  emailConversationId: string | undefined;
  showStudentId: boolean = false;
  studentIdMinTime: number = 0;
  iDashURL: string = '';
  isStitchIn: boolean = false;
  callStatus: string = 'alerting';
  callType: string = '';

  isLoading: boolean = true;
  backgroundColorStyle: string = '';
  selectedDispositionOption: DispositionReasonValue | undefined;
  validLeadOptions: DispositionReasonValue[] | undefined;
  unverifiedLeadOptions: DispositionReasonValue[] | undefined;
  uiConfiguration: UIConfiguration[] | undefined;
  inquiryId: number | undefined;
  dialerContactId: number | undefined;
  telecomDialerCampaignName: string | null | undefined;
  accountId: number | undefined;
  syStaffId: number | undefined;
  studentFinanceMsg: string = '';
  otherInfoMsg: string = '';
  displayPartner: boolean = false;
  partnerTextColor: string = '';
  dialCountDownTimer: number = 0;
  initialDialCountDownTimer: number = 0;
  dialNoActionCountDownThreshold: number = 0;
  validDispositionMinTime: number = 0;
  callButtonDisabled: boolean = false;
  dialButtonClicked: boolean = false;
  displayDialCountDownTimer: boolean = true;
  disconnectCallRequest: DisconnectCallRequest | undefined;
  markUncallableRequest: MarkUncallableRequest | undefined;
  disconnectEmailRequest: DisconnectEmailRequest | undefined;
  bannerWarning: boolean = false;
  cannotAutoSubmit: boolean = false;
  isConsentConfirmed: boolean | null = false;

  callTimer: number = 0;
  callTimerInterval: any = null;

  dispositionTimer: number = 0;
  dispositionTimerInterval: any = null;
  autoDispositionLimit: number | undefined;
  dispositionNotifyNoActionLimit: number | undefined;
  minTimeBeforeLimit: number = 10;

  emailIcon: string = 'message-email';
  SMSIcon: string = 'fa/message-lines-regular';

  dialText: string = "Dial"

  PSTSMSAllowed: boolean | undefined;
  PSTEmailAllowed: boolean | undefined;
  PSTLabel: string = '';
  PSTFailurePopupShow: boolean = false;

  PSTSMSDisabled: boolean = false;
  PSTSMSAttempts: number | undefined;
  PSTSMSDelay: number | undefined;
  PSTSMSDelayTimer: number = 0;
  totalSMSAttempts: number = 0;

  PSTEmailDisabled: boolean = false;
  PSTEmailAttempts: number | undefined;
  PSTEmailDelay: number | undefined;
  PSTEmailDelayTimer: number = 0;
  totalEmailAttempts: number = 0;

  confirmationDialogComponentRef: MatDialogRef<ConfirmationDialogComponent> | null = null;
  agentParticipantId: string | undefined;
  leadConversationState: LeadConversationState | undefined;
  isAutoDisposition: boolean = false;
  timeSubscription: Subscription | undefined;
  today: string = '';
  retainConsentOptions: any;
  consentDisabled: boolean = false;
  partnerLeadDisplayName: string = '';
  initialConsent: boolean = false;
  dispositionTimerStarted: boolean = false;
  showPST: boolean = false;
  dialTimerInterval: any = null;
  manualConsent: boolean | null = null;
  displayOtherInfo: boolean = false;
  isInitialized = signal(false);

  currentPhoneNumber: string | null | undefined = null;

  get PSTEnabled(): boolean | undefined {
    return this.pstService.PSTEnabled && this.callStatus === 'connected';
  }

  iscallPresented: boolean = false;

  callButtonDisabledInAlert: boolean = false;
  
  get DialDisabled(): boolean {
    return !(this.callStatus === 'waiting' || this.callStatus === 'alerting' || this.callStatus === 'presenting') || this.callType === 'OutgoingCall' || this.callType === 'IncomingCall' || this.callButtonDisabled || this.callButtonDisabledInAlert;
  }


  constructor(
    private readonly dispositionService: DispositionService,
    private readonly admissionsService: AdmissionsService,
    private readonly commonDataService: AdmissionUICommonDataService,
    private readonly userService: UserService,
    private readonly dialerService: DialerContactService,
    private readonly messenger: AdmissionUIMessengerService,
    private readonly callService: CallService,
    private readonly dialog: MatDialog,
    private readonly genesysSparkWrapperService: GenesysSparkWrapperService,
    private readonly toastService: ToastService,
    private readonly pstService: PSTService,
    private readonly dialerCampaignService: DialerCampaignsService,
    private readonly leadConversationStateStore: LeadConversationStateStore,
    private readonly dateFormatterUtils: DateFormatterUtils,
    private readonly leadService: LeadService,
    private readonly appInsightsService: AppInsightsService,
    private readonly conversationUtils: ConversationUtils
  ) {
    effect(() => {
      this.leadConversationState = this.leadConversationStateStore.getState()();
      this.studentData = this.leadConversationState.Student!;
      this.studentId = this.studentData?.id!;
      this.emailConversationId = this.leadConversationState.Email?.id;
      this.callStatus = this.leadConversationState.CallStatus ?? 'Not Set';
      if (this.commonDataService.terminatedStatus.includes(this.callStatus)) {
        this.displayOtherInfo = true;
      }
      this.agentParticipantId = this.leadConversationStateStore.emailAgentParticipant()?.id;
      this.callType = this.leadConversationState.CallType ?? '';
      this.conversationId = this.leadConversationState.Call?.id;

      if (!this.isInitialized()) return;
      if (this.callStatus === 'connected') {
        this.stopDialTimer();
        this.startCallTimer();
      }

      if (this.commonDataService.terminatedStatus.includes(this.callStatus)) {
        this.PSTSMSDisabled = true;
        this.PSTEmailDisabled = true;
        this.startDispositionTimer();
      }
      if (this.leadConversationState.CallConversationId) {
          this.callButtonDisabled = true;
          this.displayDialCountDownTimer = false;
      }
      else if (this.leadConversationState.Email && this.leadConversationStateStore.isEmailConnected(this.leadConversationState.Email) && this.studentId) {
        this.currentPhoneNumber = this.getLeadFlowPhoneFromEmail(this.leadConversationState.Email);
        this.dial();
      }

      this.callTimer = this.leadConversationStateStore.getCallDuration();
      this.previousUserCallStatus = this.leadConversationState?.PreviousUserStatus ?? "Available";
    });
  }

  ngOnInit() {
    this.today = this.dateFormatterUtils.formatHourMinuteSecond(new Date());
    this.updateTime();
    this.messenger.consentConfirmed?.subscribe(consentConfirmed => {
      this.isConsentConfirmed = consentConfirmed;
      if (this.isConsentConfirmed) {
        this.otherInfoMsg = '';
      }
      else {
        this.otherInfoMsg = 'Confirm Consent to Call Again.';
      }
    });

    this.commonDataService.isStitchIn?.subscribe(isStitchIn => {
      this.isStitchIn = isStitchIn;
      if (this.isStitchIn) {
        this.displayOtherInfo = true;
      }
    });

    this.commonDataService.previousUserStatus?.subscribe(previousUserStatus => {
      this.previousUserCallStatus = previousUserStatus;
    });

    this.initializeComponents().subscribe(_ => {
      if (this.callStatus === 'connected') {
        this.startCallTimer();
      }
      this.isLoading = false;
      this.isInitialized.set(true);
      if (["callback", "dialercall"].includes(this.callType.toLocaleLowerCase()) && this.leadConversationState && this.leadConversationState.Email 
        && this.leadConversationStateStore.isEmailAlerting(this.leadConversationState.Email) && !this.conversationId) {
        this.startDialTimer();
      }
    });
  }

  ngOnDestroy() {
    if (this.timeSubscription) {
      this.timeSubscription.unsubscribe();
    }
    if (this.dialTimerInterval) {
      clearInterval(this.dialTimerInterval);
      this.dialTimerInterval = null;
    }
    // Clear call timer interval
    if (this.callTimerInterval) {
      clearInterval(this.callTimerInterval);
      this.callTimerInterval = null;
    }

    this.conversationId = undefined;
    this.emailConversationId = undefined;
    this.iscallPresented = false;
  }

  private initializeComponents(): Observable<null> {
    return new Observable<null>(obs => {
      this.genesysSparkWrapperService.register().then(() => {
        const loadStudentData = this.loadStudentData();
        const loadUserData = this.loadUserData();
        const loadDispositionData = this.loadDispositionData();
        const loadUIConfiguration = this.loadUIConfiguration();
        const isPartnerLeadSource = this.isPartnerLeadSource();
        try {
          combineLatest([loadStudentData, loadUserData, loadDispositionData, isPartnerLeadSource, loadUIConfiguration]).subscribe(_ => {
            this.handleOutboundDial();
            this.appInsightsService.logEvent('Disposition-Components Initialized', {
              conversationId: this.emailConversationId || this.conversationId
            });
            this.CallPresented();
            obs.next(null);
          });
        } catch (error) {          
          console.error('Error initializing components:', error);   
        }
      });
    });
  }

  private loadStudentData(): Observable<null> {
    return new Observable<null>(obs => {
      this.studentData = this.leadConversationState!.Student!;
      if (this.studentData) {
        if (this.studentData.schoolFields?.find(obj => obj.schoolField?.id === 68)?.value?.toUpperCase() === 'Y') {
          this.initialConsent = true;
          this.manualConsent = true;
          this.consentDisabled = true;
          this.isConsentConfirmed = true;
          this.consentConfirmed();
        }
        else {
          this.initialConsent = false;
          this.consentDisabled = false;
          this.isConsentConfirmed = null;
          this.consentConfirmed();
        }
        this.inquiryId = this.studentData?.inquiries?.find(obj => obj.isCurrent === true)?.id;
        if (this.inquiryId) {
          if(this.leadConversationState?.Email?.id) {
            const customerParticipant = this.conversationUtils.getCustomerParticipant(this.leadConversationState.Email);
            const attrs: any = customerParticipant?.attributes;
            if (attrs) {
              // Set dialerContactId from LeadFlow_LionDialerContactId, LeadFlow_Campaign
              this.telecomDialerCampaignName = attrs['LeadFlow_Campaign']
              const contactIdRaw = attrs['LeadFlow_LionDialerContactId'];
              const parsedId = contactIdRaw ? parseInt(contactIdRaw, 10) : NaN;
              this.dialerContactId = parsedId;
              this.leadConversationStateStore.updateDialerContactId(parsedId.toString());

              // Build callSkills from any attribute keys starting with 'LeadFlow_Skill'
              const skillsFromAttrs: string[] = Object.keys(attrs)
                .filter(k => k.startsWith('LeadFlow_Skill') && !!attrs[k])
                .map(k => attrs[k]);
              if (skillsFromAttrs.length) {
                // Merge with any existing callSkills, avoiding duplicates
                const merged = Array.from(new Set([...(this.callSkills || []), ...skillsFromAttrs]));
                this.callSkills = merged;
              }
            }
            obs.next(null);
          }
          else {
            this.dialerService.apiDialerContactGetByInquiryIdGet(this.inquiryId).subscribe((data : DialerContactResponse) => {
              this.dialerContactId = data.id;
              this.telecomDialerCampaignName = data.telecomDialerCampaignName
              if (this.dialerContactId) {
                this.leadConversationStateStore.updateDialerContactId(this.dialerContactId.toString());
                this.leadConversationStateStore.updateTelecomDialerCampaignName(this.telecomDialerCampaignName!);
              }
              if (data.leadSkills) {
                data.leadSkills.forEach(skill => {
                  if (skill.id) {
                    this.callSkills.push(skill.id);
                  }
                });
              }
              obs.next(null);
            });            
          }
        }
        else {
          obs.next(null);
        }
      }
    });
  }

  private loadUserData(): Observable<any> {
    const apiAccountGet$ = this.userService.apiAccountGet().pipe(catchError(e => of({ id: -1 })));
    const apiStaffGet$ = this.userService.apiSyStaffGet().pipe(catchError(e => of({ id: -1 })));
    return combineLatest([apiAccountGet$, apiStaffGet$]).pipe(
      switchMap(([apiAccountGet, apiStaffGet]) => {
        this.syStaffId = apiStaffGet.id;
        this.accountId = apiAccountGet.id;
        return of(null);
      })
    );
  }

  private loadDispositionData() {
    return new Observable<null>(obs => {
      const ValidDispositions = this.dispositionService.apiDispositionValidDispositionReasonValueGet('Outgoing')
      const InvalidDispositions = this.dispositionService.apiDispositionInvalidDispositionReasonValueGet(this.studentData?.campus?.id!);
      combineLatest([ValidDispositions, InvalidDispositions]).subscribe(([ValidDispositions, InvalidDispositions]) => {
        this.unverifiedLeadOptions = InvalidDispositions;
        this.validLeadOptions = ValidDispositions;
        if (this.unverifiedLeadOptions) {
          this.dialerCampaignService.apiCampaignInvalidLeadDialerCampaignSettingsGet().subscribe(data => {
            this.getRetainConsentOptions(data);
          });
        }

        obs.next(null);
      });
    });
  }
  getRetainConsentOptions(data: InvalidLeadDialerCampaignSettingsResponse[]) {
    this.retainConsentOptions = {};
    if (this.unverifiedLeadOptions) {
      for (const lead of this.unverifiedLeadOptions) {
        if (lead?.id !== undefined) {
          this.retainConsentOptions[lead.id] = data.find(obj => obj.invalidLeadReasonPropertyValue?.id === lead.id)?.retainTCPAConsent;
        }
      }
    }
  }

  private loadUIConfiguration(): Observable<null> {
    return new Observable<null>(obs => {
      this.commonDataService.getUIConfigurationAndSchoolStatuses().subscribe(data => {
        this.uiConfiguration = data.uiConfiguration;
        if (this.uiConfiguration) {
          this.setupUIConfiguration();
        }
        obs.next(null);
      });
    })
  }

  private isPartnerLeadSource(): Observable<null> {
    return new Observable<null>(obs => {
      this.leadService.apiLeadIsPartnerLeadSourceGet(this.studentData.leadSource?.code!).subscribe(data => {
        this.displayPartner = data.field === true;
        if (this.displayPartner) {
          this.setupPartnerLeads();
          this.leadService.apiLeadGetPartnerLeadDisplayNameGet(this.studentData.leadSource?.code!).subscribe(data => {
            this.partnerLeadDisplayName = data.field || '';
            obs.next(null);
          });
        } else obs.next(null);
      });
    })
  }

  private setupUIConfiguration() {
    if (this.studentData) {
      this.setupStudentDataUI();
    }
    this.setupDialTimer();
    this.setupDispositionTimers();
    this.setupPSTConfiguration();
  }

  private setupStudentDataUI() {
    this.setupIDashURL();
    this.setupLeadDate();
    this.setupReferralLeads();
    this.setupStudentIdDisplay();
  }

  private setupIDashURL() {
    const iDashBaseURL = this.uiConfiguration?.find(obj => obj.key === 'LsIdash.Url')?.value;
    if (iDashBaseURL && this.studentData?.id !== undefined) {
      this.iDashURL = iDashBaseURL + this.studentData?.id;
    }
  }

  private setupReferralLeads() {
    const referralLeads = this.uiConfiguration?.find(obj => obj.key === 'LeadSource.ReferralLead')?.value?.split(',') || [];
    if (this.studentData?.leadSource?.code && referralLeads.includes(this.studentData?.leadSource?.code)) {
      const referralColor = this.uiConfiguration?.find(obj => obj.key === 'LeadSource.ReferralLead.Color')?.value;
      if (referralColor) {
        this.backgroundColorStyle = "background-color: " + referralColor;
      }
    }
  }

  private setupPartnerLeads() {
    if (this.displayPartner) {
      const tempPartnerColor = this.uiConfiguration?.find(obj => obj.key === 'LeadSource.PartnerLead.Color')?.value;
      if (tempPartnerColor) {
        this.partnerTextColor = tempPartnerColor;
      }
    }
  }

  private setupLeadDate() {
    if (this.studentData?.leadDate) {
      const now = new Date();
      const leadDate = new Date(this.studentData?.leadDate);
      const diffTime = Math.abs(now.getTime() - leadDate.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays < 10 && !this.isStitchIn) {
        this.backgroundColorStyle = "background-color: " + this.uiConfiguration?.find(obj => obj.key === 'Background.LeadAge.0-10')?.value;
      }
    }
  }

  private setupStudentIdDisplay() {
    this.showStudentId = this.uiConfiguration?.find(obj => obj.key === 'DispositionWindow.ShowStudentId.Enable')?.value === '1';
    const studentIdMinTime = this.uiConfiguration?.find(obj => obj.key === 'DispositionWindow.ShowStudentId.Seconds')?.value;
    if (studentIdMinTime) {
      this.studentIdMinTime = parseInt(studentIdMinTime)
    }
  }

  private setupDialTimer() {
    const dialCountDownTime = this.uiConfiguration?.find(obj => obj.key === 'Dial.CountdownTime')?.value;
    if (dialCountDownTime) {
      this.initialDialCountDownTimer = parseInt(dialCountDownTime);
    }

    const dialNoActionThreshold = this.uiConfiguration?.find(obj => obj.key === 'Dial.NotifyNoActionSeconds')?.value;
    if (dialNoActionThreshold) {
      this.dialNoActionCountDownThreshold = parseInt(dialNoActionThreshold);
    }
  }

  private setupDispositionTimers() {
    const validDispositionTime = this.uiConfiguration?.find(obj => obj.key === 'Disposition.ValidLead.ContactedEngaged.EnableIfDurationSeconds')?.value;
    if (validDispositionTime) {
      this.validDispositionMinTime = parseInt(validDispositionTime);
    }

    const autoDispositionTime = this.uiConfiguration?.find(obj => obj.key === 'Disposition.AutoDispositionSeconds')?.value;
    if (autoDispositionTime) {
      this.autoDispositionLimit = parseInt(autoDispositionTime);
    }

    const notifyNoActionTime = this.uiConfiguration?.find(obj => obj.key === 'Disposition.NotifyNoActionSeconds')?.value;
    if (notifyNoActionTime) {
      this.dispositionNotifyNoActionLimit = parseInt(notifyNoActionTime);
    }
  }

  private setupPSTConfiguration() {
    this.pstService.initializePSTConfiguration(this.uiConfiguration!, this.studentData);
    this.PSTLabel = this.pstService.PSTLabel;
    this.PSTFailurePopupShow = this.pstService.PSTFailurePopupShow;
    this.PSTSMSAllowed = this.pstService.PSTSMSAllowed;
    this.PSTEmailAllowed = this.pstService.PSTEmailAllowed;

    this.PSTSMSDisabled = this.leadConversationState!.PSTSMSDisabled ?? this.pstService.PSTSMSDisabled;
    this.PSTEmailDisabled = this.leadConversationState!.PSTEmailDisabled ?? this.pstService.PSTEmailDisabled;
  }

  handleOutboundDial() {
    if (this.callType === 'OutgoingCall' && (this.emailConversationId === undefined || this.emailConversationId === null)
      && !this.leadConversationState!.Call) {
      // In this case the phoneNumber should come from the dialpad, which is in the leadConversationState.PhoneNumber
      this.currentPhoneNumber = this.leadConversationState!.PhoneNumber;
      this.dial()
    }
  }

  consentConfirmedSelected(consentSelection: boolean) {
    this.manualConsent = consentSelection
    this.consentConfirmed(consentSelection);
  }


  consentConfirmed(isConfirmed: boolean | null = this.isConsentConfirmed) {
    // Log consent confirmation action with AppInsights
    this.appInsightsService.logEvent('DispositionScreen_ConsentConfirmed', {
      studentId: this.studentData?.id,
      isConfirmed: isConfirmed,
      callStatus: this.callStatus
    });

    this.messenger.setConsentConfirmed(isConfirmed);
    if (isConfirmed) {
      this.otherInfoMsg = '';
    }
    else {
      this.otherInfoMsg = 'Confirm Consent to Call Again.';
    }
  }

  startDialTimer() {
    if (this.isLoading) return;
    if (this.dialButtonClicked || this.callStatus === 'connected' || this.leadConversationState?.CallConversationId) {
      this.stopDialTimer();
      return;
    }
    this.dispositionTimerStarted = false;
    if(this.dispositionTimerInterval){
      clearInterval(this.dispositionTimerInterval);
      this.dispositionTimerInterval = null;
    }
    if (this.dialTimerInterval) {
      clearInterval(this.dialTimerInterval);
      this.dialTimerInterval = null;
    }

    this.dialCountDownTimer = this.initialDialCountDownTimer;
    if (this.dialCountDownTimer > 0 && !this.dialButtonClicked) {
      this.callButtonDisabled = false;
      if (this.dialCountDownTimer !== null && this.dialCountDownTimer !== undefined && this.dialCountDownTimer > 0) {
        this.dialTimerInterval = setInterval(() => {
          if (this.dialButtonClicked || this.callStatus === 'connected' || this.leadConversationState?.CallConversationId) {
            this.stopDialTimer();
            return;
          }
          this.dialCountDownTimer--;
          if (!this.dialButtonClicked) {
            if (this.dialCountDownTimer <= this.dialNoActionCountDownThreshold) {
              this.bannerWarning = true;
            }
          }
          if (this.dialCountDownTimer <= 0) {
            this.callButtonDisabledInAlert = true;
            this.stopDialTimer();
            this.handleMissedCall();
          }
        }, 1000);
      }
    }
    else {
      this.displayDialCountDownTimer = false;
    }
  }

  private stopDialTimer(): void {
    this.displayDialCountDownTimer = false;
    if (this.dialTimerInterval !== null) {
      clearInterval(this.dialTimerInterval);
      this.dialTimerInterval = null;
    }
  }


  private handleMissedCall() {
    this.displayDialCountDownTimer = false;
    combineLatest([
      this.admissionsService.apiAdmissionOutboundCallCallMissedPost({
        conversationId: this.emailConversationId || this.conversationId,
        dialerContactId: this.dialerContactId,
        syStudentInquiryId: this.inquiryId,
        syStudentId: this.studentId,
        accountId: this.accountId
      }),
      this.leadConversationStateStore.declineMissedEmail()
    ]).subscribe(() => {
    });
  }

  startSMSDisabledTimer() {
    this.pstService.startSMSDisabledTimer(() => {
      if (!this.pstService.isMaxSMSAttemptsReached(this.totalSMSAttempts)) {
        this.PSTSMSDisabled = false;
        this.leadConversationStateStore.updatePstSMSDisabled(false);
      }
    });
  }

  startEmailDisabledTimer() {
    this.pstService.startEmailDisabledTimer(() => {
      if (!this.pstService.isMaxEmailAttemptsReached(this.totalEmailAttempts)) {
        this.PSTEmailDisabled = false;
        this.leadConversationStateStore.updatePstEmailDisabled(false);
      }
    });
  }

  startCallTimer() {
    if (this.callTimerInterval) {
      if (this.commonDataService.terminatedStatus.includes(this.callStatus)) {
        clearInterval(this.callTimerInterval);
        this.callTimerInterval = null; // Reset the interval tracker
      }
      return; // If the timer is already running, do nothing
    }
    this.admissionsService.apiAdmissionOutboundCallCallConnectedPost({
      conversationId: this.conversationId,
      dialerContactId: this.dialerContactId,
      syStudentInquiryId: this.inquiryId,
      syStudentId: this.studentId,
      accountId: this.accountId
    }).subscribe(() => {});

    if (this.validDispositionMinTime) {
      this.callTimerInterval = setInterval(() => {
        // Recalculate the timer based on the timestamp
        this.callTimer = this.leadConversationStateStore.getCallDuration();
        this.showPST = this.callTimer >= this.pstService.pstConnectedDuration;
        if (this.commonDataService.terminatedStatus.includes(this.callStatus)) {
          clearInterval(this.callTimerInterval);
          this.callTimerInterval = null; // Reset the interval tracker
        }
      }, 1000);
    }
  }

  startDispositionTimer() {
    if (this.dispositionTimerStarted) {
      return;
    }

    //clearing dial timer if running
    this.displayDialCountDownTimer = false;
    if (this.dialTimerInterval) {
      clearInterval(this.dialTimerInterval);
      this.dialTimerInterval = null;
    }

    this.dispositionTimerStarted = true;
    this.messenger.setWaitingOnDispositionCrossDomain(true);

    // Initialize timer with current duration
    this.dispositionTimer = this.leadConversationStateStore.getDispositionDuration();

    this.leadConversationStateStore.dispositionInterval = setInterval(() => {
      // Recalculate the timer based on the timestamp
      this.dispositionTimer = this.leadConversationStateStore.getDispositionDuration();

      if (this.autoDispositionLimit) {
        if (this.dispositionTimer >= this.autoDispositionLimit && !this.cannotAutoSubmit) {
          this.isAutoDisposition = true;
          this.selectedDispositionOption = this.validLeadOptions?.find(obj => obj.id === 147);
          this.submit();
          clearInterval(this.leadConversationStateStore.dispositionInterval);
        }
      }

      if (this.dispositionNotifyNoActionLimit) {
        if (this.dispositionTimer >= this.dispositionNotifyNoActionLimit) {
          this.bannerWarning = true;
        }
      }
    }, 1000);
  }

  dispositionDial() {
    this.currentPhoneNumber = this.getLeadFlowPhoneFromEmail(this.leadConversationState!.Email);
    // Set LocalTouch to true for all emailCalls
    const isLocalTouch = this.leadConversationState!.Email ? true : null;
    const telecomInteractionType = this.leadConversationState!.CallType ? this.leadConversationState!.CallType : null;
    this.dial(isLocalTouch, telecomInteractionType);
  }

  getLeadFlowPhoneFromEmail(email: any): string | null {
    // Get participant where purpose is 'customer'
    const customerParticipant = email.participants?.find((p: any) => p.purpose === 'customer');
    if (customerParticipant?.attributes?.LeadFlow_Phone) {
      return customerParticipant.attributes.LeadFlow_Phone;
    }
    return null;
  }

  //#region dial
  dial(isLocalTouch: boolean | null = null, telecomInteractionType: string | null = null) {
    if (this.callButtonDisabled || this.dialButtonClicked) return;

    // Get student id from studentData
    const studentId = this.studentData?.id;
    this.prepareForDial(this.currentPhoneNumber, studentId);

    if (!this.hasValidDialParams(this.currentPhoneNumber, studentId)) {
      this.handlePreconditionFailure();
      return;
    }

    // Change callstatus to loading to prevent multiple simultaneous calls, via singalR
    this.messenger.setCallState('loading');

      this.commonDataService
        .dial(
          studentId!,
          this.currentPhoneNumber!,
          this.inquiryId!,
          this.dialerContactId!,
          this.accountId!,
          this.emailConversationId,
          this.agentParticipantId,
          isLocalTouch,
          telecomInteractionType
        )
        .subscribe({
          next: resp => this.handleSuccessDialResponse(resp),
          error: err => this.handleDialError(err),
          complete: () => {
            // finalize logic (e.g. re-enable buttons) if needed
          }
        });
  }
  //#endregion
private CallPresented() {
  if(this.iscallPresented || (!this.emailConversationId && !this.conversationId)) return; 
  const postBody = {
              telecomInteractionType: this.callType,
              conversationId: this.emailConversationId || this.conversationId,
              dialerContactId: this.dialerContactId,
              syStudentInquiryId: this.inquiryId,
              syStudentId: this.studentId,
              accountId: this.accountId,
              callDirection: 'Incoming'
            };                        
    this.admissionsService
      .apiAdmissionOutboundCallCallPresentedPost(postBody)
      .subscribe({
        next: (response) => {        
        },        error: (error) => {
          this.appInsightsService.logEvent('CallPresented-Error', {postBody, error });
        }
      });
      this.iscallPresented = true;
  }
  //#region prepareForDial
  private prepareForDial(phoneNumber: string | null | undefined, studentId: number | undefined) {
    this.dialButtonClicked = true;
    this.bannerWarning = false;
    this.callButtonDisabled = true;
    this.stopDialTimer();

    this.appInsightsService.logEvent('DispositionScreen_DialAttempt', {
      studentId: studentId,
      phoneNumber: phoneNumber,
      inquiryId: this.inquiryId,
      dialerContactId: this.dialerContactId,
      callType: this.callType,
      emailConversationId: this.emailConversationId
    });

  }
  //#endregion

  //#region hasValidDialParams
  private hasValidDialParams(phoneNumber: string | null | undefined, studentId: number | undefined): boolean {
    return (
      !!phoneNumber &&
      !!studentId &&
      !!this.inquiryId &&
      !!this.accountId &&
      !!this.dialerContactId &&
      (this.callType === 'OutgoingCall' || !!this.emailConversationId)
    );
  }
  //#endregion

  //#region handlePreconditionFailure
  private handlePreconditionFailure() {
    const statusToRestore = this.previousUserCallStatus; // Capture before async flows may clear state
    this.appInsightsService.logEvent(
      'DispositionScreen_DialPreconditionFailure',
      {
        studentId: this.studentData?.id,
        phoneNumber: this.studentData?.phoneDigits,
        inquiryId: this.inquiryId,
        accountId: this.accountId,
        dialerContactId: this.dialerContactId,
        callType: this.callType,
        emailConversationId: this.emailConversationId
      }
    );
    let phoneNumber = this.studentData?.phoneDigits!;

    this.toastService.show({
      body: 'Unable to place call.',
      classname: 'bg-danger text-light',
      delay: 5000,
      header: 'Dial Error'
    });

    const disconnect$ =
      this.callType.toLocaleLowerCase() === 'callback' && this.emailConversationId
        ? this.admissionsService
          .apiAdmissionDisconnectEmailPost({ conversationId: this.emailConversationId })
          .pipe(
            switchMap(() =>
              this.commonDataService.toggleUserStatus(statusToRestore)
            )
          )
        : this.commonDataService.toggleUserStatus(statusToRestore);

    disconnect$.subscribe(() => this.leadConversationStateStore.endInteraction(phoneNumber));
  }
  //#endregion

  //#region handleSuccessResponse
  private handleSuccessDialResponse(resp: any) {
    if (resp.id) {
      this.appInsightsService.logEvent('DispositionScreen_DialSuccess', {
        studentId: this.studentData.id,
        phoneNumber: this.studentData.phoneDigits,
        conversationId: resp.id
      });

      this.conversationId = resp.id;
      this.leadConversationStateStore.updateCallStatus("dialing");
      this.leadConversationStateStore.getCallConversation(resp.id);
      this.toastService.show({
        body: 'Dialing ' + this.studentData.phoneDigits,
        classname: 'bg-success text-light',
        delay: 5000,
        header: 'Dialing...'
      });
      this.CallPresented();
    } else if (resp.error) {
      this.handleDialResponseError(resp);
    }
  }
  //#endregion

  //#region handleDialError
  private handleDialError(err: any) {
    let errMsg = 'Unable to connect call';
    if (err.error?.[0]?.errors) {
      errMsg = err.error[0].errors[0];
    }

    const statusToRestore = this.previousUserCallStatus; // Preserve target status before state resets

    this.appInsightsService.logEvent('DispositionScreen_DialFailure', {
      studentId: this.studentData?.id,
      phoneNumber: this.studentData?.phoneDigits,
      errorMessage: errMsg,
      errorDetails: JSON.stringify(err)
    });
    let phoneNumber = this.studentData?.phoneDigits!;
    this.toastService.show({
      body: errMsg,
      classname: 'bg-danger text-light',
      delay: 5000,
      header: 'Dial Failed'
    });

    setTimeout(() => {
      this.commonDataService
        .toggleUserStatus(statusToRestore)
        .subscribe(() => this.leadConversationStateStore.endInteraction(phoneNumber));
    }, 2000);

    return [];
  }
  //#endregion

  //#region handleResponseError
  private handleDialResponseError(resp: any) {
    this.appInsightsService.logEvent('DispositionScreen_DialResponseError', {
      studentId: this.studentData.id,
      phoneNumber: this.studentData.phoneDigits,
      error: resp.error
    });
    let phoneNumber = this.studentData?.phoneDigits!;
    const statusToRestore = this.previousUserCallStatus; // Preserve target status before state resets
    if (resp.errorCode === '1') {
      this.markUncallableAndDisconnectEmail();
    }
    this.toastService.show({
      body: resp.error,
      classname: 'bg-danger text-light',
      delay: 5000,
      header: `Dial Failed`
    });
    if (this.emailConversationId) {
      this.leadConversationStateStore.disconnectDispostionedEmail();
    }

    setTimeout(() => {
      this.commonDataService
        .toggleUserStatus(statusToRestore)
        .subscribe(() => this.leadConversationStateStore.endInteraction(phoneNumber));
    }, 2000);
  }
  //#endregion
  //#region markUncallableAndDisconnectEmail
  private markUncallableAndDisconnectEmail() {
    this.admissionsService
      .apiAdmissionOutboundCallMarkUncallablePost({ id: this.dialerContactId! })
      .subscribe(res => {
        if (!res.success) return;

        this.appInsightsService.logEvent(
          'DispositionScreen_MarkUncallable_Success',
          {
            studentId: this.studentData.id,
            phoneNumber: this.studentData.phoneDigits,
            dialerContactId: this.dialerContactId
          }
        );

        if (this.emailConversationId) {
          this.admissionsService
            .apiAdmissionDisconnectEmailPost({ conversationId: this.emailConversationId })
            .subscribe(disRes => {
              if (disRes.success) {
                this.appInsightsService.logEvent(
                  'DispositionScreen_EmailDisconnect_Success',
                  {
                    studentId: this.studentData.id,
                    phoneNumber: this.studentData.phoneDigits,
                    conversationId: this.emailConversationId
                  }
                );
              }
            });
        }
      });
  }
  //#endregion
  disconnect() {
    // Log disconnect action with AppInsights
    this.appInsightsService.logEvent('DispositionScreen_Disconnect', {
      studentId: this.studentData?.id,
      conversationId: this.conversationId,
      callStatus: this.callStatus,
      callDuration: this.callTimer
    });

    this.startDispositionTimer();
    this.disconnectCallRequest = {
      conversationId: this.conversationId!
    };

    this.callService.apiCallDisconnectPost(this.disconnectCallRequest).subscribe(resp => {

      // Log disconnect response with AppInsights
      this.appInsightsService.logEvent('DispositionScreen_DisconnectResponse', {
        studentId: this.studentData?.id,
        conversationId: this.conversationId,
        responseState: resp.state
      });

      combineLatest([
        this.admissionsService.apiAdmissionOutboundCallCallDisconnectedPost({
          accountId: this.accountId,
          syStudentId: this.studentId,
          conversationId: this.conversationId,
          isCallPlaced: true,
          wasAnswered: true,
          dialerContactId: this.dialerContactId,
          syStudentInquiryId: this.inquiryId
        }),
        this.admissionsService.apiAdmissionOutboundCallCallDispositioningPost()
      ]).subscribe(() => {
      });
    });
  }

  dnc() {
    // Log DNC action with AppInsights
    this.appInsightsService.logEvent('DispositionScreen_DNCSelected', {
      studentId: this.studentData?.id,
      conversationId: this.conversationId || this.emailConversationId,
      dispositionTimerValue: this.dispositionTimer
    });
    this.messenger.setPage('DNC');
  }

  displayPSTFailurePopUp(PSTMsg: string) {

    const dialogData = {
      mode: CONFIRM_DIALOG_MODE.OK,
      title: 'Failed To Send PST',
      messageArray: [PSTMsg],
      messageCentered: true
    };
    this.confirmationDialogComponentRef = this.dialog.open(ConfirmationDialogComponent, { data: dialogData });

  }

  private handlePSTNotification(type: 'SMS' | 'Email') {
    // Log PST notification request with AppInsights
    this.appInsightsService.logEvent('DispositionScreen_PSTNotification', {
      studentId: this.studentData?.id,
      notificationType: type,
      totalAttempts: type === 'SMS' ? this.totalSMSAttempts : this.totalEmailAttempts
    });

    if (type === 'SMS') {
      this.PSTSMSDisabled = true;
      this.leadConversationStateStore.updatePstSMSDisabled(true);
      this.totalSMSAttempts++;
    } else {
      this.PSTEmailDisabled = true;
      this.leadConversationStateStore.updatePstEmailDisabled(true);
      this.totalEmailAttempts++;
    }

    this.pstService.sendPSTNotification(this.studentData.id!, type).subscribe((resp: SendPstNotificationResponse) => {
      if (type === 'SMS') {
        this.startSMSDisabledTimer();
      } else {
        this.startEmailDisabledTimer();
      }
      if (resp.success) {
        if (resp.data?.messageSent) {
          // Log successful PST notification with AppInsights
          this.appInsightsService.logEvent('DispositionScreen_PSTNotificationSuccess', {
            studentId: this.studentData?.id,
            notificationType: type,
            responseData: resp.data
          });

          if (type === 'SMS') {
            this.SMSIcon = 'fa/message-check-solid';
          } else {
            this.emailIcon = 'fa/circle-check-solid';
          }
        } else {
          this.PSTNotificationFailure(type);
        }
      }
      else {
        this.PSTNotificationFailure(type);
      }
    });
  }

  PSTNotificationFailure(type: 'SMS' | 'Email') {
    // Log PST notification failure with AppInsights
    this.appInsightsService.logEvent('DispositionScreen_PSTNotificationFailure', {
      studentId: this.studentData?.id,
      notificationType: type
    });

    if (type === 'SMS') {
      this.SMSIcon = 'fa/message-xmark-solid';
    } else {
      this.emailIcon = 'fa/circle-xmark-solid';
    }
    const PSTMsg = 'The attempt to send PST link via ' + type + ' failed.';
    this.displayPSTFailurePopUp(PSTMsg);
  }

  SMSClicked() {
    this.handlePSTNotification('SMS');
  }

  emailClicked() {
    this.handlePSTNotification('Email');
  }

  async submit() {
    // Log submit attempt with detailed payload
    this.appInsightsService.logEvent('DispositionScreen_SubmitAttempt', {
      studentId: this.studentData?.id,
      conversationId: this.conversationId || this.emailConversationId,
      selectedDispositionId: this.selectedDispositionOption?.id,
      selectedDispositionValue: this.selectedDispositionOption?.value,
      isConsentConfirmed: this.isConsentConfirmed,
      callDuration: this.callTimer,
      dispositionTimer: this.dispositionTimer,
      isAutoDisposition: this.isAutoDisposition
    });

    if (!this.isAutoDisposition) {
      const potentialStudent = this.validLeadOptions?.find(obj => obj.value === 'Spoke with Potential Student');
      if (!this.isConsentConfirmed && this.selectedDispositionOption?.id === potentialStudent?.id && !(await this.handleConsentWarning())) {
        // Log consent warning cancellation
        this.appInsightsService.logEvent('DispositionScreen_ConsentWarningCancelled', {
          studentId: this.studentData?.id,
          conversationId: this.conversationId || this.emailConversationId
        });
        return;
      }
    }
    else if (this.confirmationDialogComponentRef) {
      this.confirmationDialogComponentRef.close();
    }

    this.commonDataService.setSelectedDispositionOption(this.selectedDispositionOption);

    if (this.selectedDispositionOption) {
      if (this.validLeadOptions?.includes(this.selectedDispositionOption)) {
        await this.handleValidDisposition();
      } else if (this.unverifiedLeadOptions?.includes(this.selectedDispositionOption)) {
        await this.handleInvalidDisposition();
      }
    }
  }

  private async handleConsentWarning(): Promise<boolean> {
    const submitWarningChoice = await this.displaySubmitWarning();

    // Log consent warning response
    this.appInsightsService.logEvent('DispositionScreen_ConsentWarningResponse', {
      studentId: this.studentData?.id,
      response: submitWarningChoice ? 'Proceed' : 'Cancel'
    });

    if (!submitWarningChoice) {
      return false;
    }
    return true;
  }

  private async handleValidDisposition() {
    let phoneNumber = this.leadConversationState!.PhoneNumber;
    let previousUserStatus = this.previousUserCallStatus;
    let contactedDisposition = parseInt(this.uiConfiguration?.find(obj => obj.key === 'Disposition.ValidLead.ContactedEngaged.Id')?.value || '0');
    if (this.selectedDispositionOption?.id === contactedDisposition && !this.isAutoDisposition && this.isConsentConfirmed) {
      this.messenger.setPage('Schedule');
    } else {
      this.cannotAutoSubmit = true;
      const validDispositionRequest = this.createValidDispositionRequest();
      // Log valid disposition handling
      this.appInsightsService.logEvent('DispositionScreen_ValidDispositionSubmit', validDispositionRequest)
      const dispositionPost$ = this.dispositionService.apiDispositionValidDispositionRequestedPost(validDispositionRequest);
      const disconnectEmail$ = this.emailConversationId
        ? this.leadConversationStateStore.disconnectDispostionedEmail()
        : of(null);

      forkJoin([dispositionPost$, disconnectEmail$]).subscribe({
        next: () => {
          this.leadConversationStateStore.endInteraction(phoneNumber!);
          this.commonDataService.toggleUserStatus(previousUserStatus).subscribe();
        },
        error: (error) => {
          // Log disposition submission error
          this.appInsightsService.logException(new Error('Valid disposition submission failed'), 2);
          this.appInsightsService.logEvent('DispositionScreen_ValidDispositionError', {
            studentId: this.studentData?.id,
            dispositionId: this.selectedDispositionOption?.id,
            error: JSON.stringify(error)
          });
        }
      });
    }
  }

  private async handleInvalidDisposition() {

    this.cannotAutoSubmit = true;
    let phoneNumber = this.leadConversationState!.PhoneNumber;
    let previousUserStatus = this.previousUserCallStatus;
    const invalidDispositionRequest = this.createInvalidDispositionRequest();
    // Log invalid disposition handling
    this.appInsightsService.logEvent('DispositionScreen_InvalidDispositionSubmit', invalidDispositionRequest);

    const dispositionPost$ = this.dispositionService.apiDispositionInvalidDispositionRequestedPost(invalidDispositionRequest);
    const disconnectEmail$ = this.emailConversationId
      ? this.leadConversationStateStore.disconnectDispostionedEmail()
      : of(null);

    forkJoin([dispositionPost$, disconnectEmail$]).subscribe({
      next: () => {
        this.leadConversationStateStore.endInteraction(phoneNumber!);
        this.commonDataService.toggleUserStatus(previousUserStatus).subscribe();
        // Log successful invalid disposition submission
        this.appInsightsService.logEvent('DispositionScreen_InvalidDispositionSuccess', {
          studentId: this.studentData?.id,
          dispositionId: this.selectedDispositionOption?.id,
          conversationId: this.conversationId || this.emailConversationId
        });

      },
      error: (error) => {
        // Log disposition submission error
        this.appInsightsService.logException(new Error('Invalid disposition submission failed'), 2);
        this.appInsightsService.logEvent('DispositionScreen_InvalidDispositionError', {
          studentId: this.studentData?.id,
          dispositionId: this.selectedDispositionOption?.id,
          error: JSON.stringify(error)
        });
      }
    });
  }

  private createValidDispositionRequest(): ValidDispositionRequested {
    let dispositionConversationId = this.conversationId || this.emailConversationId
    let consent = this.isConsentConfirmed ?? undefined;
    return {
      conversationId: dispositionConversationId!,
      reason: { id: this.selectedDispositionOption?.id, value: this.selectedDispositionOption?.value },
      dialerContactId: this.dialerContactId,
      interactionType: this.callType,
      skills: this.callSkills,
      interviewResult: '',
      phone: this.studentData?.phoneDigits,
      syStudentId: this.studentData?.id,
      sySchoolFields: this.studentData?.schoolFields,
      telecomDialerCampaignName: this.telecomDialerCampaignName,
      tcpaConsentGiven: consent,
      accountId: this.accountId,
      syStaffId: this.syStaffId,
      syStudentInquiryId: this.inquiryId,
      admissionsRepresentativeId: this.studentData?.admissionsRepresentative?.id
    };
  }

  private createInvalidDispositionRequest(): InvalidDispositionRequested {
    let dispositionConversationId = this.conversationId || this.emailConversationId;
    let consent = this.isConsentConfirmed ?? undefined;
    return {
      conversationId: dispositionConversationId!,
      reason: { id: this.selectedDispositionOption?.id, value: this.selectedDispositionOption?.value },
      dialerContactId: this.dialerContactId,
      interactionType: this.callType,
      skills: this.callSkills,
      interviewResult: '',
      phone: this.studentData?.phoneDigits,
      tcpaConsentGiven: consent,
      syStudentInquiryId: this.inquiryId,
      syStudentId: this.studentData?.id,
      accountId: this.accountId,
      syStaffId: this.syStaffId,
      telecomDialerCampaignName: this.telecomDialerCampaignName,
      admissionsRepresentativeId: this.studentData?.admissionsRepresentative?.id,
      sySchoolFields: this.studentData?.schoolFields
    };
  }

  async close() {
    let dispositionConversationId = this.conversationId || this.emailConversationId
    const canCreateActivity = this.uiConfiguration?.find(obj => obj.key === 'StitchInWindow.CanCreateActivity')?.value === '1';
    let phoneNumber = this.leadConversationState!.PhoneNumber;
    const stitchInCallRequest: StitchInCallRequested = {
      conversationId: dispositionConversationId!,
      dialerContactId: this.dialerContactId,
      interactionType: this.callType,
      skills: this.callSkills,
      interviewResult: '',
      syStudentId: this.studentData?.id,
      telecomDialerCampaignName: this.telecomDialerCampaignName,
      syStaffId: this.syStaffId,
      syStudentInquiryId: this.inquiryId,
      accountId: this.accountId,
      canCreateActivity: canCreateActivity,
      reason: { id: this.commonDataService.stitchInCall?.id , value: this.commonDataService.stitchInCall?.value }
    }

    this.dispositionService.apiDispositionStitchInCallRequestedPost(stitchInCallRequest).subscribe({
      next: (apiResponse) => {
      },
      error: (err) => {
        console.error('Error during Stitch In Call Request: ', JSON.stringify(err));
        alert('Error during Stitch In Call Request - check console.log for details');

      }
    });
    this.commonDataService.toggleUserStatus(this.previousUserCallStatus).subscribe(() => {
    });
    this.leadConversationStateStore.endInteraction(phoneNumber!);
  }

  htmlToText(html: string | null | undefined): string {
    if (html === null || html === undefined) {
      return '';
    } else {
      const text = convertHtmlToText(html);
      const lines = text.split('\n');
      const trimmedLines = lines.map(line => line.trimStart());
      const trimmedText = trimmedLines.join('\n');
      return trimmedText;
    }
  }

  async displaySubmitWarning(): Promise<boolean> {
    const dialogData = {
      mode: CONFIRM_DIALOG_MODE.YES_NO,
      title: 'Consent Is Not Checked',
      messageArray: ["Without Consent, this lead will be placed on DNC. Is consent set correctly?"],
      messageCentered: true
    };

    return new Promise<boolean>((resolve) => {
      this.confirmationDialogComponentRef = this.dialog.open(ConfirmationDialogComponent, { data: dialogData, disableClose: true });
      this.confirmationDialogComponentRef.afterClosed().subscribe(resp => {
        resolve(!!resp); // Resolve the promise with the response (true/false)
      });
    });
  }

  validDispositionDisabled(option: DispositionReasonValue): boolean {
    if (!(this.callStatus === 'disconnected' || this.callStatus === 'terminated' || this.callStatus === 'transferred')) {
      return true;
    }
    if (option.id === 147) {
      return this.callTimer <= this.validDispositionMinTime

    }
    else {
      return this.callTimer > this.validDispositionMinTime
    }
  }

  updateTime(): void {
    this.timeSubscription = interval(1000).subscribe(() => {
      this.today = this.dateFormatterUtils.formatHourMinuteSecond(new Date());
    });
  }

  validOptionSelected(option: DispositionReasonValue) {
    // Log when valid disposition option is selected
    this.appInsightsService.logEvent('DispositionScreen_ValidOptionSelected', {
      studentId: this.studentData?.id,
      selectedOption: this.selectedDispositionOption?.value,
      selectedOptionId: this.selectedDispositionOption?.id,
      callTimer: this.callTimer
    });
    let contactedDisposition = parseInt(this.uiConfiguration?.find(obj => obj.key === 'Disposition.ValidLead.ContactedEngaged.Id')?.value || '0');
    if (option?.id === contactedDisposition) {
      this.isConsentConfirmed = this.manualConsent
      this.consentConfirmed();
      if (!this.initialConsent) this.consentDisabled = false;
    }
    else {
      this.consentDisabled = true;
      this.isConsentConfirmed = this.initialConsent;
    }

  }

  invalidOptionSelected(option: DispositionReasonValue) {
    // Log when invalid disposition option is selected
    this.appInsightsService.logEvent('DispositionScreen_InvalidOptionSelected', {
      studentId: this.studentData?.id,
      selectedOption: option?.value,
      selectedOptionId: option?.id,
      retainConsent: option?.id !== undefined && this.retainConsentOptions[option.id]
    });
    if (option) {
      if (option?.id !== undefined && this.retainConsentOptions[option.id] && !this.initialConsent) {
        this.consentDisabled = false;
        this.isConsentConfirmed = this.manualConsent;
        this.consentConfirmed(this.isConsentConfirmed);
        return;
      }
      else if (option?.id !== undefined && !this.initialConsent) {
        this.consentDisabled = true;
        this.isConsentConfirmed = false;
        this.consentConfirmed();
      }
    }
  }

}
